import { Box, Typography, Button, Paper, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useState } from 'react';

const SimplePDFViewer = ({ pdfFile, title, description }) => {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: 3, 
          mb: 3, 
          borderRadius: 2, 
          border: '1px solid', 
          borderColor: 'divider'
        }}
      >
        <Typography variant="h4" gutterBottom component="h1">
          {title}
        </Typography>
        {description && (
          <Typography variant="body1" color="text.secondary" paragraph>
            {description}
          </Typography>
        )}
        
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
          <Button 
            variant="outlined" 
            size="small" 
            startIcon={<DownloadIcon />}
            href={pdfFile}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download
          </Button>
        </Box>
      </Paper>
      
      <Paper 
        elevation={0} 
        sx={{ 
          p: 0, 
          borderRadius: 2, 
          border: '1px solid', 
          borderColor: 'divider',
          position: 'relative',
          height: '80vh',
          overflow: 'hidden'
        }}
      >
        {loading && (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
            bgcolor: 'background.paper'
          }}>
            <CircularProgress />
          </Box>
        )}
        
        <iframe
          src={`${pdfFile}#toolbar=1&navpanes=1&scrollbar=1`}
          title={title}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          onLoad={handleIframeLoad}
        />
      </Paper>
    </Box>
  );
};

export default SimplePDFViewer; 